import { batchActions } from './utils';
import { setData, unsetData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, UNAUTHORIZED, selectEpisodeMetadataStatus } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, EpisodeMetadata } from '../types';

export const LOAD_EPISODE_START_STREAMS = 'LOAD_EPISODE_START_STREAMS';
const KEY = 'episodeMetadata';

export const loadEpisodeMetadata = (episodeId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const endpoint = `${PODCASTERS_SERVICE}/v0/episodes/${episodeId}/metadata`;

  /* istanbul ignore next */
  if (selectEpisodeMetadataStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [KEY]: LOADING }, 'audience/LOAD_EPISODE_METADATA_REQUEST'));

  try {
    const data: EpisodeMetadata = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [KEY]: data }), unsetStatus([KEY])],
        'audience/LOAD_EPISODE_METADATA_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        if (err.message === '403') {
          dispatch(setStatus({ [KEY]: UNAUTHORIZED }, 'audience/LOAD_UNAUTHORIZED'));
        } else {
          dispatch(setStatus({ [KEY]: ERROR }, 'audience/LOAD_EPISODE_METADATA_ERROR'));
        }
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};

export const unsetEpisodeMetadata = /* istanbul ignore next */ (): Thunk => async dispatch =>
  dispatch(unsetData([KEY]));
